<template>
  <div>
    <section class="section wavier-content">
      <div class="container">
        <div class="columns is-mobile is-centered rules has-text-weight-medium has-text-justified">
          <div class="column is-10">
            <div v-html="data.content" class="content-html"></div>
          </div>
        </div>
      </div>
    </section>
    <section class="section waiver-form">
      <div class="container">
        <div class="columns is-mobile is-centered form">
          <div class="column is-10 border-box">
            <div class="ng-untouched ng-pristine ng-invalid">
              <div formgroupname="adultData" class="adult ng-untouched ng-pristine ng-invalid">
                <h5 class="title is-5">
                  <span class="icon mr-2"><img src="@/assets/img/id.svg" alt="-" /></span>Parent / Guardian Information
                </h5>
                <div class="columns is-multiline">
                  <div class="column is-5-desktop is-half-tablet">
                    <div class="field">
                      <label for="firstName" class="label">First Name</label>
                      <div class="control">
                        <input name="firstName" v-model="form.first_name" @blur="(e) => blurError(e, 'first_name')"
                          type="text" formcontrolname="firstName"
                          class="input form-control ng-untouched ng-pristine ng-invalid" />
                      </div>
                      <p v-if="first_name_error" class="help is-danger">
                        Error: First name is required.
                      </p>
                      <span v-else class="help has-text-grey">Note: Please enter your legal name.</span>
                    </div>
                  </div>
                  <div class="column is-5-desktop is-half-tablet">
                    <div class="field">
                      <label for="lastName" class="label">Last Name</label>
                      <div class="control">
                        <input name="lastName" v-model="form.last_name" @blur="(e) => blurError(e, 'last_name')"
                          type="text" formcontrolname="lastName"
                          class="input form-control ng-untouched ng-pristine ng-invalid" />
                      </div>
                      <p v-if="last_name_error" class="help is-danger">
                        Error: Last name is required.
                      </p>
                      <span v-else class="help has-text-grey">Note: Please enter your legal name.</span>
                    </div>
                  </div>
                  <div class="column is-5-desktop is-half-tablet">
                    <div class="field">
                      <label for="gender" class="label">Gender</label>
                      <div class="control">
                        <div class="select is-fullwidth">
                          <select id="gender" v-model="form.gender" name="gender" formcontrolname="gender"
                            class="form-control ng-untouched ng-pristine ng-valid">
                            <option value="0">Female</option>
                            <option value="1">Male</option>
                            <option value="2">Not Specified</option>
                          </select>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column is-5-desktop is-half-tablet">
                    <div class="field">
                      <label for="dob" class="label">Date of Birth</label>
                      <div class="control">
                        <el-date-picker v-model="form.birth_date" type="date" placeholder="select" format="MM/dd/yyyy"
                          value-format="yyyy-MM-dd" :picker-options="expireTimeOPtion" @change="changeFirstBirthDate">
                        </el-date-picker>
                      </div>
                      <p v-if="firstBirthDateError" class="help is-danger">
                        Error: {{ firstBirthDateText }}
                      </p>
                      <span v-else class="help bold">Note: You must be 18+ to fill out this waiver.</span>
                    </div>
                  </div>
                  <div class="column is-5-desktop is-half-tablet">
                    <div class="field is-expanded">
                      <label for="phone" class="label">Phone Number</label>
                      <div class="field has-addons">
                        <div class="control">
                          <a class="button is-static"> +1 </a>
                        </div>
                        <div class="control is-expanded">
                          <input type="text" v-model="form.phone_umber" @input="handleInput" @blur="blurPhone"
                            name="phone" maxlength="13" formcontrolname="phone"
                            class="input ng-untouched ng-pristine ng-invalid" />
                          <p v-if="phone_error_1" class="help is-danger">
                            Error: Please check your phone number.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                  <div class="column is-5-desktop is-half-tablet">
                    <div class="field">
                      <label for="email" class="label">Email</label>
                      <div class="control has-icons-left">
                        <input v-model="form.email" @input="blurErrorEmail" type="email" name="email"
                          formcontrolname="email" class="input ng-untouched ng-pristine ng-invalid" />
                        <!-- <span class="icon is-small is-left"
                          ><i class="fas fa-envelope"></i
                        ></span> -->
                        <p v-if="email_error" class="help is-danger">
                          Error: Please input correct email address.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div formgroupname="address" class="columns is-multiline ng-untouched ng-pristine ng-invalid">
                  <div class="column is-12 address-label">
                    <label class="label">Address</label>
                  </div>
                  <div class="column is-5-desktop is-half-tablet">
                    <input v-model="form.address_line1" type="street" id="street1" placeholder="Address Line 1"
                      formcontrolname="street1" required=""
                      class="input form-control ng-untouched ng-pristine ng-invalid" />
                  </div>
                  <div class="column is-5-desktop is-half-tablet">
                    <input v-model="form.address_line2" type="street" id="street2" placeholder="Address Line 2"
                      formcontrolname="street2" class="input form-control ng-untouched ng-pristine ng-valid" />
                  </div>
                  <div class="column is-5-desktop is-half-tablet">
                    <input v-model="form.city" type="city" id="city" placeholder="City" formcontrolname="city" city=""
                      required="" class="input form-control ng-untouched ng-pristine ng-invalid" />
                  </div>
                  <div class="column is-3-desktop is-3-tablet">
                    <div class="control">
                      <div class="select is-fullwidth">
                        <el-select v-model="form.state_id">
                          <el-option v-for="item in stateListInfo" :key="item.id" :label="item.name" :value="item.id">
                          </el-option>
                        </el-select>
                      </div>
                    </div>
                  </div>
                  <div class="column is-2-desktop is-3-tablet is-5-mobile">
                    <input v-model="form.zip" type="text" id="zip" placeholder="Zip" formcontrolname="zip"
                      pattern="[0-9]*" maxlength="5" required="" @input="blurZip" @blur="blurZip"
                      class="input form-control ng-untouched ng-pristine ng-invalid" style="width: 60%" />
                    <p v-if="zip_error" class="help is-danger">
                      Error: Please check your zip.
                    </p>
                  </div>
                </div>
                <div formgroupname="emergencyContact" class="columns is-multiline ng-untouched ng-pristine ng-valid">
                  <div class="column is-5-desktop is-half-tablet">
                    <div class="field is-expanded">
                      <label for="emergencyNumber" class="label">Emergency Contact Number (Optional)</label>
                      <div class="field has-addons">
                        <div class="control">
                          <a class="button is-static"> +1 </a>
                        </div>
                        <div class="control is-expanded">
                          <input type="text" v-model="form.emergency_contact" @input="handleInput1" @blur="blurPhone2"
                            name="emergencyNumber" maxlength="13" formcontrolname="emergencyNumber"
                            class="input ng-untouched ng-pristine ng-invalid" />
                          <p v-if="phone_error_2" class="help is-danger">
                            Error: Please check your phone number.
                          </p>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div formgroupname="participantsData" class="participants ng-untouched ng-pristine ng-invalid">
                <h5 class="title is-5 is-spaced">
                  <span class="icon mr-2">
                    <img src="@/assets/img/friends.svg" alt="-" />
                  </span>
                  Participants Information
                </h5>
                <p class="subtitle is-6 has-text-dark">
                  This waiver could only be submitted when there is at least one
                  participant (either yourself or other participants). Please
                  ensure that you add all the participants and check the box
                  below if you will be participating the activities. Thank you!
                </p>
                <div class="columns">
                  <div class="column">
                    <div class="form-group">
                      <label for="ifAdultPlay" class="checkbox has-text-weight-medium has-text-dark"><input
                          v-model="is_signer_play" type="checkbox" id="ifAdultPlay" name="ifAdultPlay"
                          formcontrolname="ifAdultPlay" class="mr-2 ng-untouched ng-pristine ng-valid" />Please check here
                        if adults on this waiver will be
                        participating in the activities.
                      </label>
                    </div>
                  </div>
                </div>
                <div v-for="(item, index) in participants_list" :key="index" formarrayname="minors"
                  class="form-group ng-untouched ng-pristine ng-invalid">
                  <div class="ng-untouched ng-pristine ng-invalid">
                    <div class="columns is-multiline">
                      <div class="column is-5-desktop is-half-tablet">
                        <div class="field">
                          <label for="firstName" class="label">First Name</label>
                          <div class="control">
                            <input v-model="item.first_name" name="firstName" type="text" formcontrolname="firstName"
                              class="input form-control ng-untouched ng-pristine ng-invalid" />
                          </div>
                          <span class="help has-text-grey">Note: Please enter your legal name.</span>
                        </div>
                      </div>
                      <div class="column is-5-desktop is-half-tablet">
                        <div class="field">
                          <label for="lastName" class="label">Last Name</label>
                          <div class="control">
                            <input v-model="item.last_name" name="lastName" type="text" formcontrolname="lastName"
                              class="input form-control ng-untouched ng-pristine ng-invalid" />
                          </div>
                          <span class="help has-text-grey">Note: Please enter your legal name.</span>
                        </div>
                      </div>
                      <div class="column is-5-desktop is-half-tablet">
                        <div class="field">
                          <label for="gender" class="label">Gender</label>
                          <div class="control">
                            <div class="select is-fullwidth">
                              <select id="gender" v-model="item.gender" name="gender" formcontrolname="gender"
                                class="form-control ng-untouched ng-pristine ng-valid">
                                <option value="0">Female</option>
                                <option value="1">Male</option>
                                <option value="2">Not Specified</option>
                              </select>
                            </div>
                          </div>
                        </div>
                      </div>
                      <div class="column is-5-desktop is-half-tablet">
                        <div class="field">
                          <label for="dob" class="label">Date of Birth</label>
                          <div class="control">
                            <el-date-picker v-model="item.birth_date" type="date" placeholder="select" format="MM/dd/yyyy"
                              value-format="yyyy-MM-dd" :picker-options="expireTimeOPtion"
                              @change="(e) => changeOtherBirthDate(e, index)">
                            </el-date-picker>
                            <p v-if="childError[index]" class="help is-danger">
                              Error: Please check the date of birth.
                            </p>
                          </div>
                        </div>
                      </div>
                      <div class="column is-12">
                        <a id="removeButton" class="button is-light is-rounded" @click="remove(item, index)">
                          Remove
                        </a>
                      </div>
                    </div>
                  </div>
                </div>

                <hr />
                <div class="columns">
                  <div class="column">
                    <button type="button" id="addButton" :style="{ backgroundColor : config.button_bgcolor}" class="button is-primary is-rounded" :disabled="disabled"
                      @click="addMore">
                      {{
                        participants_list.length > 0
                        ? "Add One More"
                        : "Add One Participant "
                      }}
                    </button>
                  </div>
                </div>
              </div>
              <div class="confirmation">
                <h5 class="title is-5">
                  <span class="icon mr-2"><img src="@/assets/img/check.svg" alt="-" /></span>Confirm and Signature
                </h5>
                <div class="columns is-centered">
                  <div class="column">
                    <p>
                      <strong>Signature</strong>: Sign in the canvas below and
                      confirm your signature.
                    </p>
                  </div>
                </div>
                <div class="has-text-centered">
                  <div v-if="!imgurl"
                    class="columns is-multiline is-gapless has-text-centered is-centered is-vcentered flex-direction-column">
                    <div class="is-6-desktop is-full-mobile canvas-wrap">
                      <canvas ref="canvas" @mousedown="startDrawing" @mousemove="draw"
                        @mouseup="stopDrawing" @touchstart="start" @touchmove="move" @touchend="end"></canvas>
                      <p v-if="!isDraw && saveDraw" class="help is-danger">
                        Error: Please check your signature.
                      </p>
                    </div>
                    <div class="column is-full">
                      <button id="sig-confirmButton" type="button"
                        class="button is-primary is-outlined is-rounded has-text-weight-medium mr-2"
                        :style="{ borderColor: config.button_bgcolor, '--hover-color': config.button_bgcolor ? config.button_bgcolor : '#de4c50', color: config.button_bgcolor }"
                        @click="saveSignature">
                        Confirm Signature
                      </button>
                      <button type="button" id="sig-clearBtn" class="button is-light is-rounded" @click="clearCanvas">
                        Clear
                      </button>
                    </div>
                  </div>
                  <div class="has-text-centered"></div>
                  <div class="columns justify-content-center" v-if="imgurl">
                    <img width="300" height="150" alt="Confirmed Signature" :src="imgurl" />
                  </div>
                </div>
              </div>
              <div formgroupname="confirmData" class="checkboxes mt-5 ng-untouched ng-pristine ng-invalid">
                <div class="columns">
                  <div class="column">
                    <div>
                      <label for="mailList" class="checkbox has-text-weight-medium has-text-dark">
                        <input v-model="protocol_2" type="checkbox" id="mailList" name="mailList"
                          formcontrolname="mailList" class="mr-2 ng-untouched ng-pristine ng-valid" />
                        I'd like to receive special offers or special activities
                        through emails / text messages from KidsTopia.
                      </label>
                    </div>
                  </div>
                </div>
                <div class="columns">
                  <div class="column">
                    <div class="form-group">
                      <label for="confirmInfoCorrect" class="checkbox has-text-weight-medium has-text-dark">
                        <span class="red">*</span>
                        <input v-model="protocol_3" type="checkbox" id="confirmInfoCorrect" name="confirmInfoCorrect"
                          formcontrolname="confirmInfoCorrect" class="mr-2 ng-untouched ng-pristine ng-invalid" />
                        I certify that I am the parent or legal guardian of the
                        above minors and confirm that the information I entered
                        is complete, accurate and true.
                      </label>
                    </div>
                  </div>
                </div>
                <div class="columns justify-content-center justify-content-sm-start">
                  <div class="column is-12">
                    <div class="form-group">
                      <label for="confirmAgreeTerms" class="checkbox has-text-weight-medium has-text-dark">
                        <span class="red">*</span>
                        <input v-model="protocol_4" type="checkbox" id="confirmAgreeTerms" name="confirmAgreeTerms"
                          formcontrolname="confirmAgreeTerms" class="mr-2 ng-untouched ng-pristine ng-invalid" />
                        I confirm I carefully read and agree to the terms of the
                        above agreement. I understand that electronically
                        certifying this waiver document just as if I would
                        physically sign it if it was on paper.
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="columns">
                <div class="column">
                  <p><strong>Date</strong>: {{ getCurrentDateString() }}</p>
                </div>
              </div>
              <div class="columns is-centered mt-4">
                <div class="column is-full-mobile is-4-tablet is-3-desktop has-text-centered">
                  <el-button :loading="loading" type="submit" id="submitButton"
                    class="button is-primary is-rounded is-fullwidth has-text-weight-medium" @click="submit"
                    :disabled="submitDisable" :style="{
                      cursor: submitDisable ? 'not-allowed' : 'pointer',
                      backgroundColor : config.button_bgcolor
                    }">
                    Submit
                  </el-button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  </div>
</template>
<script>
import { stateList, addWavier } from "@/server/api.js";
import store from "@/store";
export default {
  props: {
    data: {
      default: {},
      type: Object,
    },
  },
  components: {},
  data () {
    return {
      loading: false,
      isDrawing: false,
      saveDraw: false,
      isDraw: false,
      context: null, // Canvas上下文
      lastX: 0, // add by kate 
      lastY: 0, // add by kate 
      // ctx: null,
      imgurl: null,
      stateListInfo: [],
      // 基础信息的手机校验
      phone_error_1: false,
      phone_error_2: false,
      zip_error: false,
      form: {
        first_name: "",
        last_name: "",
        gender: "0",
        birth_date: "",
        email: "",
        address_line1: "",
        address_line2: "",
        city: "",
        state_id: "",
        zip: "",
        phone_umber: "",
        emergency_contact: "",
      },
      participants_list: [
        {
          first_name: "",
          last_name: "",
          gender: "0",
          birth_date: null,
        },
      ],
      disabled: true,
      submitDisable: true,
      is_signer_play: false,
      protocol_2: false,
      protocol_3: false,
      protocol_4: false,
      first_name_error: false,
      last_name_error: false,
      email_error: false,
      expireTimeOPtion: {
        disabledDate (time) {
          return time.getTime() > Date.now() - 8.64e6;
        },
      },
      firstBirthDateError: false,
      firstBirthDateText: "",
      childError: []
    };
  },
  computed: {
    config() {
      return store.state.global.configList || {};
    },
  },
  watch: {
    form: {
      handler (newValue) {
        var newInfo = JSON.parse(JSON.stringify(newValue));
        delete newInfo.emergency_contact;
        var formTag;
        if (!newValue.address_line1 && !newValue.address_line2) {
          formTag = false;
        } else {
          delete newInfo.address_line1;
          delete newInfo.address_line2;
          formTag = this.areAllValuesNonEmpty(newInfo);
        }
        var isTag = [];
        var pTag;
        for (let i = 0; i <= this.participants_list.length - 1; i++) {
          isTag.push(this.areAllValuesNonEmpty(this.participants_list[i]));
        }
        if (isTag.indexOf(false) > -1) {
          pTag = false;
        } else {
          pTag = true;
        }
        if (
          formTag &&
          pTag &&
          this.protocol_3 &&
          this.protocol_4 &&
          !this.phone_error_1 &&
          !this.phone_error_2 &&
          !this.zip_error
        ) {
          this.submitDisable = false;
        } else {
          this.submitDisable = true;
        }
      },
      // 代表在wacth里声明了firstName这个方法之后立即先去执行handler方法
      deep: true,
    },
    participants_list: {
      handler (newValue) {
        var newInfo = JSON.parse(JSON.stringify(this.form));
        delete newInfo.emergency_contact;
        var formTag;
        if (!newInfo.address_line1 && !newInfo.address_line2) {
          formTag = false;
        } else {
          delete newInfo.address_line1;
          delete newInfo.address_line2;
          formTag = this.areAllValuesNonEmpty(newInfo);
        }
        var isTag = [];
        var pTag;
        for (let i = 0; i <= newValue.length - 1; i++) {
          isTag.push(this.areAllValuesNonEmpty(newValue[i]));
        }
        if (isTag.indexOf(false) > -1) {
          this.disabled = true;
          pTag = false;
        } else {
          this.disabled = false;
          pTag = true;
        }
        if (
          formTag &&
          pTag &&
          this.protocol_3 &&
          this.protocol_4 &&
          !this.phone_error_1 &&
          !this.phone_error_2 &&
          !this.zip_error
        ) {
          this.submitDisable = false;
        } else {
          this.submitDisable = true;
        }
      },
      deep: true,
    },
    protocol_3: {
      handler (newValue) {
        var newInfo = JSON.parse(JSON.stringify(this.form));
        delete newInfo.emergency_contact;
        var formTag;
        if (!newInfo.address_line1 && !newInfo.address_line2) {
          formTag = false;
        } else {
          delete newInfo.address_line1;
          delete newInfo.address_line2;
          formTag = this.areAllValuesNonEmpty(newInfo);
        }
        var isTag = [];
        var pTag;
        for (let i = 0; i <= this.participants_list.length - 1; i++) {
          isTag.push(this.areAllValuesNonEmpty(this.participants_list[i]));
        }
        if (isTag.indexOf(false) > -1) {
          pTag = false;
        } else {
          pTag = true;
        }
        if (
          formTag &&
          pTag &&
          newValue &&
          this.protocol_4 &&
          !this.phone_error_1 &&
          !this.phone_error_2 &&
          !this.zip_error
        ) {
          this.submitDisable = false;
        } else {
          this.submitDisable = true;
        }
      },
    },
    protocol_4: {
      handler (newValue) {
        var newInfo = JSON.parse(JSON.stringify(this.form));
        delete newInfo.emergency_contact;
        var formTag;
        if (!newInfo.address_line1 && !newInfo.address_line2) {
          formTag = false;
        } else {
          delete newInfo.address_line1;
          delete newInfo.address_line2;
          formTag = this.areAllValuesNonEmpty(newInfo);
        }
        var isTag = [];
        var pTag;
        for (let i = 0; i <= this.participants_list.length - 1; i++) {
          isTag.push(this.areAllValuesNonEmpty(this.participants_list[i]));
        }
        if (isTag.indexOf(false) > -1) {
          pTag = false;
        } else {
          pTag = true;
        }
        if (
          formTag &&
          pTag &&
          this.protocol_3 &&
          newValue &&
          !this.phone_error_1 &&
          !this.phone_error_2 &&
          !this.zip_error
        ) {
          this.submitDisable = false;
        } else {
          this.submitDisable = true;
        }
      },
    },
  },
  mounted () {
    this.context = this.$refs.canvas.getContext("2d"); // get Canvas content
    
    var width = window.innerWidth;
    if(width > 600) {
      this.$refs.canvas.width = 500; // set Canvas width
      this.$refs.canvas.height = 300; // set Canvas height
    } else {
      var canvasWrap = document.getElementsByClassName('canvas-wrap')[0]
      var cWidth = canvasWrap.clientWidth;
      this.$refs.canvas.width = cWidth; // set Canvas width
      this.$refs.canvas.height = 220; // set Canvas height
    }
    

    this.move() // add by kate 
  },
  created () {
    this.getStateList();
  },
  methods: {
    changeFirstBirthDate (value) {
      if (!value) {
        this.firstBirthDateError = true;
        this.firstBirthDateText = "Please check the date of birth. ";
      } else if (value && this.isDateOfBirthUnder18(value)) {
        this.firstBirthDateError = true;
        this.firstBirthDateText = "You're not greater than 18. ";
      } else {
        this.firstBirthDateError = false;
        this.firstBirthDateText = null;
      }
    },
    isDateOfBirthUnder18 (dateOfBirth) {
      var birthDate = new Date(dateOfBirth);
      var currentDate = new Date();
      var yearsDifference = currentDate.getFullYear() - birthDate.getFullYear();
      if (
        currentDate.getMonth() < birthDate.getMonth() ||
        (currentDate.getMonth() === birthDate.getMonth() &&
          currentDate.getDate() < birthDate.getDate())
      ) {
        yearsDifference--;
      }
      return yearsDifference < 18;
    },
    changeOtherBirthDate (value, index) {
      var error = false;
      if (!value) {
        error = true;
      } else {
        error = false;
      }
      var childError = JSON.parse(JSON.stringify(this.childError))
      childError[index] = error;
      this.childError = childError;
    },
    blurError (e, type) {
      var value = e.target.value;
      if (!value) {
        this[`${type}_error`] = true;
      } else {
        this[`${type}_error`] = false;
      }
    },
    blurErrorEmail (e) {
      var value = e.target.value;
      var regEmail = /^[\w\-]+@[a-zA-Z\d\-]+(\.[a-zA-Z]{2,8}){1,2}$/gi;
      if ((value != "" && !regEmail.test(value)) || !value) {
        this.email_error = true;
      } else {
        this.email_error = false;
      }
    },
    getCurrentDateString () {
      const options = { year: "numeric", month: "long", day: "numeric" };
      const now = new Date();
      return now.toLocaleDateString("en-US", options);
    },
    handleInput (event) {
      var value = event.target.value;
      value = value.replace(/\s/g, '');
      var numReg = /^[0-9]*$/;
      var lastText = value.substring(value.length - 1, value.length);
      if (!numReg.test(lastText)) {
        var lastValue = this.formatPhoneNumber(
          value.substring(0, value.length - 1)
        );
        this.form.phone_umber = lastValue;
      } else {
        this.form.phone_umber = this.formatPhoneNumber(value);
      }
      if (this.form.phone_umber.length < 13) {
        this.phone_error_1 = true;
      } else {
        this.phone_error_1 = false;
      }
    },
    handleInput1 (event) {
      var value = event.target.value;
      value = value.replace(/\s/g, '');
      var numReg = /^[0-9]*$/;
      var lastText = value.substring(value.length - 1, value.length);
      if (!numReg.test(lastText)) {
        var lastValue = this.formatPhoneNumber(
          value.substring(0, value.length - 1)
        );
        this.form.emergency_contact = lastValue;
      } else {
        this.form.emergency_contact = this.formatPhoneNumber(value);
      }
      if (this.form.emergency_contact.length < 13 && this.form.emergency_contact.length > 0) {
        this.phone_error_2 = true;
      } else {
        this.phone_error_2 = false;
      }
    },
    blurPhone (e) {
      return;
      var value = e.target.value;
      if (value.length < 13) {
        this.phone_error_1 = true;
      } else {
        this.phone_error_1 = false;
      }
    },
    blurPhone2 (e) {
      return;
      var value = e.target.value;
      if (value.length < 13) {
        this.phone_error_2 = true;
      } else {
        this.phone_error_2 = false;
      }
    },
    blurZip (e) {
      var value = e.target.value;
      var test = /^\d{5}$/.test(value);
      if (test) {
        this.zip_error = false;
      } else {
        this.zip_error = true;
      }
    },
    async getStateList () {
      try {
        const { status, data } = await stateList({});
        if (status == 0) {
          this.form.state_id = data.items[0].id;
          this.stateListInfo = data.items;
        }
      } catch (error) { }
    },
    formatPhoneNumber (phoneNumber) {
      if (
        phoneNumber.length < 5 &&
        phoneNumber[0] == "(" &&
        phoneNumber[phoneNumber.length - 2] != ")" &&
        phoneNumber[phoneNumber.length - 1] != ")"
      ) {
        phoneNumber = `(${phoneNumber.substring(
          1,
          phoneNumber[phoneNumber.length - 1]
        )})`;
      }
      phoneNumber = phoneNumber
        .replace("(", "")
        .replace(")", "")
        .replace("-", "");

      if (phoneNumber.length > 3 && phoneNumber.length <= 6) {
        var num1 = phoneNumber.substring(0, 3);
        var num2 = phoneNumber.substring(3, phoneNumber.length);
        return `(${num1})${num2}`;
      } else if (phoneNumber.length <= 3 && phoneNumber.length > 0) {
        return `(${phoneNumber})`;
      } else if (phoneNumber.length == 0) {
        return "";
      } else {
        var num1 = phoneNumber.substring(0, 3);
        var num2 = phoneNumber.substring(3, 6);
        var num3 = phoneNumber.substring(6, phoneNumber.length);
        return `(${num1})${num2}-${num3}`;
      }
    },
    areAllValuesNonEmpty (obj) {
      return Object.values(obj).every(function (value) {
        return value !== null && value !== undefined && value !== "";
      });
    },
    // Trigger when the mouse is pressed
    startDrawing (event) {
      this.isDrawing = true; // Start drawing
      const { offsetX, offsetY } = event; // Obtain the offset of the mouse relative to Canvas
      this.context.beginPath(); // Start a new path
      this.context.moveTo(offsetX, offsetY); // Move path to mouse position
    },
    // Triggered when the mouse moves over Canvas
    draw (event) {
      if (!this.isDrawing) return; // If not in drawing, return
      const { offsetX, offsetY } = event; // Obtain the offset of the mouse relative to Canvas
      this.context.lineTo(offsetX, offsetY); // Draw Path
      this.context.stroke(); // Draw the border of the path
    },
    // Triggered when the mouse is released, used to stop drawing signatures
    stopDrawing () {
      this.isDrawing = false; // stop drawing
      this.getSignatureRatio();
    },

    // add by kate
    start (e) {
      this.isDrawing = true; // Start drawing
      this.isDraw = true;
      const vertex = this.$refs.canvas.getBoundingClientRect()
      const { clientX, clientY } = e.touches[0];
      this.lastX = clientX - vertex.left;
      this.lastY = clientY - vertex.top;
    },
    move (e) {
      if (!this.isDrawing) return;
      const vertex = this.$refs.canvas.getBoundingClientRect()
      const { clientX, clientY } = e.touches[0];
      this.context.beginPath();
      this.context.moveTo(this.lastX, this.lastY);
      this.context.lineTo(clientX - vertex.left, clientY - vertex.top);
      this.context.stroke();
      this.lastX = clientX - vertex.left;
      this.lastY = clientY - vertex.top;
    },
    end () {
      this.isDrawing = false;
      this.getSignatureRatio();
    },
    // add by kate end

    getSignatureRatio() {
      const data = this.context.getImageData(0, 0, this.$refs.canvas.width, this.$refs.canvas.height);
      let count = 0;
      for (let i = 0; i < data.data.length; i += 4) {
        if (data.data[i + 3] > 0) {
          count++;
        }
      }
      const totalPixels = data.width * data.height;
      const signatureRatio = count / totalPixels;
      // console.log("signatureRatio=====", signatureRatio * 100)
      if((signatureRatio * 100) >= 0.2) {
        this.isDraw = true;
      }
      return signatureRatio;
    },

    // clear
    clearCanvas () {
      this.isDraw = false;
      this.saveDraw = false;
      this.context.clearRect(
        0,
        0,
        this.$refs.canvas.width,
        this.$refs.canvas.height
      );
    },
    // save
    saveSignature () {
      this.saveDraw = true;
      if (this.isDraw) {
        const dataURL = this.$refs.canvas.toDataURL(); // get img base64
        this.imgurl = dataURL;
      }
    },
    // submit
    async submit () {
      try {
        if (!this.isDraw) {
          this.$message.error("Please check your signature.");
          return
        }
        this.loading = true;
        var newForm = JSON.parse(JSON.stringify(this.form));
        newForm.is_signer_play = this.is_signer_play ? 1 : 0;
        newForm.protocol = [];
        if (this.protocol_2) {
          newForm.protocol.push(2);
        }
        if (this.protocol_3) {
          newForm.protocol.push(3);
        }
        if (this.protocol_4) {
          newForm.protocol.push(4);
        }
        newForm.protocol = JSON.stringify(newForm.protocol);
        const { status, msg } = await addWavier({
          ...newForm,
          participants_info: JSON.stringify(this.participants_list),
          signature_info: this.imgurl,
        });
        if (status == 0) {
          this.$message.success("success");
          this.$emit("getData", {
            ...newForm,
            participants_info: JSON.stringify(this.participants_list),
            signature_info: this.imgurl,
          });
          // this.reload();
        } else {
          this.$message.error(msg);
        }
        this.loading = false;
      } catch (error) { }
    },
    reload () {
      this.isDrawing = false; // 是否正在绘制
      this.context = null; // Canvas上下文
      this.imgurl = null;
      this.stateListInfo = [];
      this.form = {
        first_name: "",
        last_name: "",
        gender: "0",
        birth_date: "",
        email: "",
        address_line1: "",
        address_line2: "",
        city: "",
        state_id: "",
        zip: "",
        phone_umber: "",
        emergency_contact: "",
      };
      this.participants_list = [
        {
          first_name: "",
          last_name: "",
          gender: "0",
          birth_date: null,
        },
      ];
      this.disabled = true;
      this.submitDisable = true;
      this.is_signer_play = false;
      this.protocol_2 = false;
      this.protocol_3 = false;
      this.protocol_4 = false;
      document.body.scrollTop = 0;
      document.documentElement.scrollTop = 0;
    },
    // add
    addMore () {
      this.participants_list.push({
        first_name: "",
        last_name: "",
        gender: "0",
        birth_date: null,
      });
    },
    // remove
    remove (item, index) {
      var newList = JSON.parse(JSON.stringify(this.participants_list));
      newList.splice(index, 1);
      this.participants_list = newList;
    },
  },
};
</script>
<style scoped>
.hero-body,
.section {
  padding: 3rem 1.5rem;
}

h5 {
  margin: 0px;
}

.rules {
  margin-top: 3rem;
}

input::placeholder {
  color: #b0aeae;
}

@media print,
screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}

.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}

.columns.is-mobile {
  display: flex;
}

.columns.is-centered {
  justify-content: center;
}

.columns:last-child {
  margin-bottom: -1.5rem;
}

.has-text-weight-medium {
  font-weight: 500 !important;
}

.has-text-justified {
  text-align: justify !important;
}

.columns.is-mobile>.column.is-10 {
  flex: none;
  width: 83.3333333333%;
}

@media print,
screen and (min-width: 769px) {

  .column.is-10,
  .column.is-10-tablet {
    flex: none;
    width: 83.3333333333%;
  }
}

.block:not(:last-child),
.box:not(:last-child),
.breadcrumb:not(:last-child),
.content:not(:last-child),
.highlight:not(:last-child),
.level:not(:last-child),
.message:not(:last-child),
.notification:not(:last-child),
.pagination:not(:last-child),
.progress:not(:last-child),
.subtitle:not(:last-child),
.table-container:not(:last-child),
.table:not(:last-child),
.tabs:not(:last-child),
.title:not(:last-child) {
  margin-bottom: 1.5rem;
}

.has-text-centered {
  text-align: center !important;
}

.title {
  color: #363636;
  font-family: Rubik, sans-serif;
  font-size: 2rem;
  font-weight: 600;
  line-height: 1.125;
}

.subtitle,
.title {
  word-break: break-word;
}

.is-5 {
  font-size: 1.25rem;
}

.has-text-grey-darker {
  color: #363636 !important;
}

.content-html {
  color: #363636 !important;
}

/deep/ .content-html h6 {
  font-size: 1.25rem;
  margin-bottom: 1.5rem;
  text-align: center;
}

/deep/ .content-html p {
  margin-top: 0.5rem;
}

/deep/ .content-html mark {
  background: linear-gradient(-100deg,
      hsla(48, 92%, 75%, 0.3),
      hsla(48, 92%, 75%, 0.7) 95%,
      hsla(48, 92%, 75%, 0.1));
  border-radius: 1em 0;
  padding: 0.3rem;
}

.adult,
.participants {
  padding-bottom: 5rem;
}

.subtitle em,
.subtitle span,
.title em,
.title span {
  font-weight: inherit;
}

.icon {
  align-items: center;
  display: inline-flex;
  justify-content: center;
  height: 1.5rem;
  width: 1.5rem;
}

.red {
  font-size: 16px;
  color: #e20909;
}

img {
  height: auto;
  max-width: 100%;
}

.columns {
  padding-top: 1rem;
  padding-bottom: 1rem;
}

.columns {
  margin-left: -1.5rem;
  margin-right: -1.5rem;
  margin-top: -1.5rem;
}

.column {
  display: block;
  flex-basis: 0;
  flex-grow: 1;
  flex-shrink: 1;
  padding: 1.5rem;
  box-sizing: border-box;
}

.column {
  padding-top: 0.5rem;
  padding-bottom: 0.5rem;
}

.columns.is-multiline {
  flex-wrap: wrap;
}

.columns:not(:last-child) {
  margin-bottom: calc(1.5rem - 1.5rem);
}

/deep/ .el-input--prefix .el-input__inner {
  font-size: 1rem;
}

.control.has-icons-left .input,
.control.has-icons-left .select select {
  padding-left: 2.5em;
}

.input:active,
.input:focus,
.is-active.input,
.is-active.textarea,
.is-focused.input,
.is-focused.textarea,
.select select.is-active,
.select select.is-focused,
.select select:active,
.select select:focus,
.textarea:active,
.textarea:focus {
  border-color: #e55f61;
  box-shadow: 0 0 0 0.125em rgba(229, 95, 97, 0.25);
}

.button:active,
.button:focus,
.file-cta:active,
.file-cta:focus,
.file-name:active,
.file-name:focus,
.input:active,
.input:focus,
.is-active.button,
.is-active.file-cta,
.is-active.file-name,
.is-active.input,
.is-active.pagination-ellipsis,
.is-active.pagination-link,
.is-active.pagination-next,
.is-active.pagination-previous,
.is-active.textarea,
.is-focused.button,
.is-focused.file-cta,
.is-focused.file-name,
.is-focused.input,
.is-focused.pagination-ellipsis,
.is-focused.pagination-link,
.is-focused.pagination-next,
.is-focused.pagination-previous,
.is-focused.textarea,
.pagination-ellipsis:active,
.pagination-ellipsis:focus,
.pagination-link:active,
.pagination-link:focus,
.pagination-next:active,
.pagination-next:focus,
.pagination-previous:active,
.pagination-previous:focus,
.select select.is-active,
.select select.is-focused,
.select select:active,
.select select:focus,
.textarea:active,
.textarea:focus {
  outline: none;
}

@media print,
screen and (min-width: 769px) {

  .column.is-half,
  .column.is-half-tablet {
    flex: none;
    width: 50%;
  }
}

@media screen and (min-width: 1024px) {
  .column.is-5-desktop {
    flex: none;
    width: 41.6666666667%;
  }
}

.label {
  color: #363636;
  display: block;
  font-size: 1rem;
  font-weight: 700;
}

.label:not(:last-child) {
  margin-bottom: 0.5em;
}

.control {
  box-sizing: border-box;
  clear: both;
  font-size: 1rem;
  position: relative;
  text-align: inherit;
}

.button,
.file-cta,
.file-name,
.input,
.pagination-ellipsis,
.pagination-link,
.pagination-next,
.pagination-previous,
.select select,
.textarea {
  -moz-appearance: none;
  -webkit-appearance: none;
  align-items: center;
  border: 1px solid transparent;
  border-radius: 4px;
  box-shadow: none;
  display: inline-flex;
  font-size: 1rem;
  height: 2.5em;
  justify-content: flex-start;
  line-height: 1.5;
  padding: calc(0.5em - 1px) calc(0.75em - 1px);
  position: relative;
  vertical-align: center;
  box-sizing: border-box;
}

.button {
  background-color: #fff;
  border-color: #dbdbdb;
  border-width: 1px;
  color: #363636;
  cursor: pointer;
  justify-content: center;
  padding: calc(0.5em - 1px) 1em;
  text-align: center;
  white-space: nowrap;
  font-family: Quicksand, sans-serif;
}

.input,
.select select,
.textarea {
  background-color: #fff;
  border-color: #dbdbdb;
  border-radius: 4px;
  color: #363636;
}

.input,
.textarea {
  box-shadow: inset 0 0.0625em 0.125em rgba(10, 10, 10, 0.05);
  max-width: 100%;
  width: 100%;
}

.has-text-grey {
  color: #7a7a7a !important;
}

.help {
  display: block;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}

.border-box {
  box-sizing: border-box;
}

.select.is-fullwidth select {
  width: 100%;
}

.is-fullwidth {
  width: 100%;
}

.field.has-addons {
  display: flex;
  justify-content: flex-start;
}

.button.is-static {
  background-color: #f5f5f5;
  border-color: #dbdbdb;
  color: #7a7a7a;
  box-shadow: none;
  pointer-events: none;
}

.field.has-addons .control:first-child:not(:only-child) .button,
.field.has-addons .control:first-child:not(:only-child) .input,
.field.has-addons .control:first-child:not(:only-child) .select select {
  border-bottom-right-radius: 0;
  border-top-right-radius: 0;
}

.field.has-addons .control:last-child:not(:only-child) .button,
.field.has-addons .control:last-child:not(:only-child) .input,
.field.has-addons .control:last-child:not(:only-child) .select select {
  border-bottom-left-radius: 0;
  border-top-left-radius: 0;
}

.field.has-addons .control.is-expanded {
  flex-grow: 1;
  flex-shrink: 1;
}

.field.has-addons .control:not(:last-child) {
  margin-right: -1px;
}

@media print,
screen and (min-width: 769px) {

  .column.is-12,
  .column.is-12-tablet {
    flex: none;
    width: 100%;
  }
}

.navbar-link:not(.is-arrowless):after,
.select:not(.is-multiple):not(.is-loading):after {
  border: 3px solid transparent;
  border-radius: 2px;
  border-right: 0;
  border-top: 0;
  content: " ";
  display: block;
  height: 0.625em;
  margin-top: -0.4375em;
  pointer-events: none;
  position: absolute;
  top: 50%;
  transform: rotate(-45deg);
  transform-origin: center;
  width: 0.625em;
  box-sizing: border-box !important;
}

.select:not(.is-multiple):not(.is-loading):after {
  border-color: #e55f61;
  right: 1.125em;
  z-index: 4;
}

.select select:not([multiple]) {
  padding-right: 2.5em;
}

.button.is-light {
  background-color: #f5f5f5;
  border-color: transparent;
  color: rgba(0, 0, 0, 0.7);
}

.button.is-rounded {
  border-radius: 290486px;
  padding-left: calc(1em + 0.25em);
  padding-right: calc(1em + 0.25em);
}

hr {
  border: none;
  display: block;
  height: 2px;
  margin: 1.5rem 0;
}

code,
hr {
  background-color: #f5f5f5;
}

.button.is-primary {
  background-color: #de4c50;
  border-color: transparent;
  color: #fff;
}

.button[disabled],
fieldset[disabled] .button {
  background-color: #fff;
  border-color: #dbdbdb;
  box-shadow: none;
  opacity: 0.5;
}

.button.is-rounded {
  border-radius: 290486px;
  padding-left: calc(1em + 0.25em);
  padding-right: calc(1em + 0.25em);
}

.button.is-primary[disabled],
fieldset[disabled] .button.is-primary {
  background-color: #de4c50;
  border-color: transparent;
  box-shadow: none;
}

canvas {
  border: 1px dotted #ccc;
  border-radius: 10px;
  cursor: crosshair;
  touch-action: none;
}

.columns.is-gapless {
  margin-left: 0;
  margin-right: 0;
  margin-top: 0;
}

.is-multiline {
  flex-wrap: wrap;
}

.is-vcentered {
  align-items: center;
}

.el-date-editor {
  width: 100%;
}

/deep/ .control .el-select {
  width: 100%;
}

/deep/ .control .el-icon-arrow-up:before {
  display: none;
}

@media print,
screen and (min-width: 769px) {
  .columns:not(.is-desktop) {
    display: flex;
  }
}

.columns.is-gapless:last-child {
  margin-bottom: 0;
}

.flex-direction-column {
  flex-direction: column;
}

strong {
  color: #363636;
  font-weight: 700;
}

.has-text-dark {
  color: #363636 !important;
}

@media print,
screen and (min-width: 769px) {

  .column.is-4,
  .column.is-4-tablet {
    flex: none;
    width: 33.3333333333%;
  }
}

@media screen and (min-width: 1024px) {
  .column.is-3-desktop {
    flex: none;
    width: 25%;
  }
}

.button.is-primary.is-outlined {
  background-color: initial;
  border-color: #de4c50;
  color: #de4c50;
}

.button.is-light {
  background-color: #f5f5f5;
  border-color: transparent;
  color: rgba(0, 0, 0, 0.7);
}

.button.is-primary.is-outlined.is-focused,
.button.is-primary.is-outlined.is-hovered,
.button.is-primary.is-outlined:focus,
.button.is-primary.is-outlined:hover {
  border-color: #de4c50;
  color: #fff !important;
}
.is-outlined:hover {
  background-color: var(--hover-color) !important;
  transition: background-color 0.3s; /* 平滑过渡效果 */
}

.help.is-danger {
  color: #de4c50;
}

.help {
  display: block;
  font-size: 0.75rem;
  margin-top: 0.25rem;
}
#sig-confirmButton, #sig-clearBtn {
  margin-top: 6px;
}
</style>



// WEBPACK FOOTER //
// src/pages/policy/components/SonWaiver.vue